export default __webpack_public_path__ + "static/media/map-marker.ef307f00.png";